import { useEffect } from "react";
import ReactGA from "react-ga4";
import SanityBlock from "../components/SanityBlock";
import SEO from "../api/SEO";
import Navbar from "../components/Navbar";

export default function Privacy(props) {
    const privacyData = props.privacyData;

    const seoPageTitle = props.privacyData.seoPageTitle;
    const seoPageDescription = props.privacyData.seoPageDescription;
    const seoPageAuthor = props.privacyData.seoPageAuthor;
    const seoPageType = props.privacyData.seoPageType;

    useEffect(() => {
        ReactGA.send({ hitType: "pageview", page: "Privacy Policy" });
    }, []);

    return (
        <>
            {seoPageTitle &&
                seoPageDescription &&
                seoPageAuthor &&
                seoPageType && (
                    <SEO
                        title={seoPageTitle}
                        description={seoPageDescription}
                        name={seoPageAuthor}
                        type={seoPageType}
                    />
                )}

            <div className="Navbar-Background-Global">
                <Navbar />
            </div>

            {privacyData && (
                <div className="Privacy-Terms-Text">
                    <h1>{privacyData.pageHeader}</h1>
                    <SanityBlock blocks={privacyData.privacyBody} />
                </div>
            )}
        </>
    );
}
